export var MmdModelMetadata;
(function (MmdModelMetadata) {
    /**
     * Check if the metadata is a serialization metadata
     * @param metadata Metadata to check
     * @returns `true` if the metadata is a serialization metadata
     */
    function isSerializationMetadata(metadata) {
        return metadata.containsSerializationData === true;
    }
    MmdModelMetadata.isSerializationMetadata = isSerializationMetadata;
})(MmdModelMetadata || (MmdModelMetadata = {}));
